import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  franchiseRoyaltyPlanFee: null,
  franchiseRoyaltyPlanFees: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const franchiseRoyaltyPlanFeeReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.FRANCHISEROYALTYPLANFEE_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.FRANCHISEROYALTYPLANFEE_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.FRANCHISEROYALTYPLANFEE_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    case actionTypes.FRANCHISEROYALTYPLANFEE_LISTRESET: {
      return updateState(state, { ...action.data, lastState: constants.STATE_RESET, lastScope: 'reset' });
    }
    default: {
      return state;
    }
  }
};

export default franchiseRoyaltyPlanFeeReducer;
